import { ButtonColorVariant, ButtonSize, ButtonVariant, buttonVariants } from "@/components/ui/button";
import { MonitorPlay } from "lucide-react";
import { useTranslation } from "react-i18next";

interface VideoTutorialButtonProps {
  url: string;
  label?: string;
}

export function VideoTutorialButton({ url, label }: VideoTutorialButtonProps): React.JSX.Element {
  const { t } = useTranslation("common");

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={buttonVariants({
        variant: ButtonVariant.Outlined,
        colorVariant: ButtonColorVariant.Secondary,
        size: ButtonSize.Lg,
      })}
    >
      <MonitorPlay /> {label ?? t("TutorialVideos")}
    </a>
  );
}
